var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b',{staticClass:"user-name",on:{"click":function($event){return _vm.showDialog()}}},[_vm._v(_vm._s(_vm.user.displayName))])
}
var staticRenderFns = []

export { render, staticRenderFns }